import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import ActiveSkus from "../indentation/activeskus";
import Gatepasses from "../indentation/gatepasses.js";
import Grninfo from "../indentation/grninfo.js"; //po info 
import Grninfonew from "../indentation/grninfonew.js"; // GRN info 


import CurrentStockIndentation from "./currentstockindentation";
import DemandDistributionDashboard from "./demand_distribution_data";
import IndentationCreation from "./indentaion-creation";
import WarehouseTransferrableStock from "./warehouse-transferrable-stock.js";

import "../../assets/css/inventorymanagement.css";

const DarkstoresIndentaionTabs = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);

  // 🌟 Get and set query param
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "gatepasses";
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 p-0">
            <h1
              className="col-sm-12"
              style={{
                color: "#B9366D",
                fontSize: 18,
                fontWeight: "bold",
                fontFamily: "sans-serif",
              }}
            >
              Darkstore Indentation
            </h1>
          </div>

          {/* Tabs Navigation */}
          <div className="col-sm-12 p-0 mt-3">
            <ul className="nav nav-tabs" id="calenderMasterTabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
              {[
                { id: "active_skus", label: "Active Skus" },
                { id: "gatepasses", label: "Gatepass Data" },
                // { id: "po_info", label: "PO Info" },
                // { id: "grn_info", label: "GRN Info" },
                { id: "stock_status", label: "Stock Status" },
                { id: "demand_destribution", label: "Demand Distribution" },
                { id: "raise_indents", label: "Raise Indents" },
                // { id: "warehouse_transferrable_stock", label: "Warehouse Transferable Stock" },
              ].map((tab) => (
                <li key={tab.id} className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                    type="button"
                    role="tab"
                    aria-controls={tab.id}
                    aria-selected={activeTab === tab.id}
                    style={{
                      fontSize: 14,
                      fontWeight: activeTab === tab.id ? 600 : 500,
                      color: activeTab === tab.id ? "#93385D" : "#555",
                      backgroundColor: activeTab === tab.id ? "#fff" : "#f8f9fa",
                      borderBottom: activeTab === tab.id ? "2px solid #93385D" : "none",
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content */}
          <div className="tab-content col-sm-12 p-0 mt-2 row " id="calenderMasterTabsContent">
            {activeTab === "active_skus" && <ActiveSkus />}
            {activeTab === "gatepasses" && <Gatepasses />}
            {activeTab === "po_info" && <Grninfo />}
            {activeTab === "grn_info" && <Grninfonew />}
            {activeTab === "stock_status" && <CurrentStockIndentation />}
            {activeTab === "demand_destribution" && <DemandDistributionDashboard />}
            {activeTab === "raise_indents" && <IndentationCreation />}
            {activeTab === "warehouse_transferrable_stock" && <WarehouseTransferrableStock />}
          </div>
        </div>
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: 1002 }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={`overly-block ${overlyBlock}`} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

export default DarkstoresIndentaionTabs;
